/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { faqClientControllerFindByIdV1 } from '../fn/faq-client/faq-client-controller-find-by-id-v-1';
import { FaqClientControllerFindByIdV1$Params } from '../fn/faq-client/faq-client-controller-find-by-id-v-1';
import { faqClientControllerSearchV1 } from '../fn/faq-client/faq-client-controller-search-v-1';
import { FaqClientControllerSearchV1$Params } from '../fn/faq-client/faq-client-controller-search-v-1';
import { FaqDto } from '../models/faq-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class FaqClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `faqClientControllerSearchV1()` */
  static readonly FaqClientControllerSearchV1Path = '/api/v1/faqs/client';

  /**
   * FAQ 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqClientControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqClientControllerSearchV1$Response(params: FaqClientControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = faqClientControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 목록 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqClientControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqClientControllerSearchV1(params: FaqClientControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.faqClientControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<FaqDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `faqClientControllerFindByIdV1()` */
  static readonly FaqClientControllerFindByIdV1Path = '/api/v1/faqs/client/{id}';

  /**
   * FAQ 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `faqClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqClientControllerFindByIdV1$Response(params: FaqClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqDto>> {
    const obs = faqClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * FAQ 상세 조회 (클라이언트).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `faqClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  faqClientControllerFindByIdV1(params: FaqClientControllerFindByIdV1$Params, context?: HttpContext): Observable<FaqDto> {
    const resp = this.faqClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FaqDto>): FaqDto => r.body)
    );
  }

}
